import { Component, Input, OnInit } from '@angular/core';
import { ChartConfiguration, ChartOptions, ChartType } from 'chart.js';

@Component({
  selector: 'app-performance-chart',
  templateUrl: './performance-chart.component.html',
  styleUrls: ['./performance-chart.component.scss'],
})
export class PerformanceChartComponent implements OnInit {
  @Input('type') type!: string;
  @Input('text') text!: string;
  @Input('data') data!: number[];
  @Input('data2') data2!: number[];
  @Input('noSelect') noSelect!: boolean;
  constructor() {}

  title = 'ng2-charts-demo';

  getOrCreateTooltip = (chart: any) => {
    let tooltipEl = chart.canvas.parentNode.querySelector('div');

    if (!tooltipEl) {
      tooltipEl = document.createElement('div');
      tooltipEl.style.background = 'rgb(255,1,0, 0.9)';
      tooltipEl.style.borderRadius = '30px';
      tooltipEl.style.color = 'white';
      tooltipEl.style.opacity = 1;
      tooltipEl.style.pointerEvents = 'none';
      tooltipEl.style.position = 'absolute';
      tooltipEl.style.transform = 'translate(-50%, 0)';
      tooltipEl.style.transition = 'all .1s ease';

      const table = document.createElement('table');
      table.style.margin = '0px';

      tooltipEl.appendChild(table);
      chart.canvas.parentNode.appendChild(tooltipEl);
    }

    return tooltipEl;
  };

  externalTooltipHandler = (context: any) => {
    // Tooltip Element
    const { chart, tooltip } = context;
    const tooltipEl = this.getOrCreateTooltip(chart);

    // Hide if no tooltip
    if (tooltip.opacity === 0) {
      tooltipEl.style.opacity = 0;
      return;
    }

    // Set Text
    if (tooltip.body) {
      const titleLines = tooltip.title || [];
      const bodyLines = tooltip.body.map((b: { lines: any }) => b.lines);

      const tableHead = document.createElement('thead');

      titleLines.forEach((title: string) => {
        const tr = document.createElement('tr');
        tr.style.borderWidth = '0';

        const th = document.createElement('th');
        th.style.borderWidth = '0';
        const text = document.createTextNode(title);

        // th.appendChild(text);
        // tr.appendChild(th);
        // tableHead.appendChild(tr);
      });

      const tableBody = document.createElement('tbody');
      bodyLines.forEach((body: string, i: string | number) => {
        const tr = document.createElement('tr');
        tr.style.backgroundColor = 'inherit';
        tr.style.borderWidth = '0';

        const td = document.createElement('td');
        td.style.borderWidth = '0';

        const text = document.createTextNode(body);

        //td.appendChild(span);
        td.appendChild(text);
        tr.appendChild(td);
        tableBody.appendChild(tr);
      });

      const tableRoot = tooltipEl.querySelector('table');

      // Remove old children
      while (tableRoot.firstChild) {
        tableRoot.firstChild.remove();
      }

      // Add new children
      tableRoot.appendChild(tableHead);
      tableRoot.appendChild(tableBody);
    }

    const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

    // Display, position, and set styles for font
    tooltipEl.style.opacity = 1;
    tooltipEl.style.left = positionX + tooltip.caretX + 'px';
    tooltipEl.style.top = positionY + tooltip.caretY + 'px';
    tooltipEl.style.font = tooltip.options.bodyFont.string;
    tooltipEl.style.padding = '6px 15px';
  };

  public lineChartData: ChartConfiguration<'line'>['data'] = {
    labels: [
      'Ene',
      'Feb',
      'Mar',
      'Abr',
      'May',
      'Jun',
      'Jul',
      'Ago',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    datasets: [
      {
        label: '$',
        data: this.data,
        fill: false,
        tension: 0,
        hoverBackgroundColor: 'rgb(255,1,0)',
        borderColor: 'black',
        pointRadius: 10,
        pointBackgroundColor: 'black',
        pointBorderWidth: 5,
        pointHitRadius: 20,
      },
    ],
  };
  public barChartData: ChartConfiguration<'bar'>['data'] = {
    labels: [
      'Ene',
      'Feb',
      'Mar',
      'Abr',
      'May',
      'Jun',
      'Jul',
      'Ago',
      'Sep',
      'Oct',
      'Nov',
      'Dic',
    ],
    datasets: [
      {
        label: '$',
        data: this.data2,
        backgroundColor: 'rgb(215,236,251)',
        hoverBackgroundColor: 'rgb(255,1,0, 0.7)',
      },
    ],
  };
  public lineChartOptions: ChartOptions<'line'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
        onClick: () => {},
      },
      tooltip: {
        enabled: false,
        position: 'average',
        xAlign: 'right',
        external: this.externalTooltipHandler,
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || '';

            if (label) {
              label = '';
            }
            if (context.parsed.y !== null) {
              label = new Intl.NumberFormat('es-cl', {
                style: 'currency',
                currency: 'CLP',
              }).format(context.parsed.y);
            }
            return label;
          },
        },
      },
    },
    scales: {
      y: {
        ticks: {
          // Include a dollar sign in the ticks
          callback: function (value: any, index, values) {
            return '$' + parseInt((value / 1000000).toFixed(1)) + ' M';
          },
          stepSize: 1000000,
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  };
  public barChartOptions: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
        onClick: () => {},
      },
      tooltip: {
        enabled: false,
        position: 'nearest',
        external: this.externalTooltipHandler,
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || '';

            if (label) {
              label = '';
            }
            if (context.parsed.y !== null) {
              label = new Intl.NumberFormat('es-cl', {
                style: 'currency',
                currency: 'CLP',
              }).format(context.parsed.y);
            }
            return label;
          },
        },
      },
    },
    scales: {
      y: {
        ticks: {
          // Include a dollar sign in the ticks
          callback: function (value, index, values) {
            return value + ' CLP';
          },
          stepSize: 50000,
        },
        beginAtZero: true,
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  };
  public lineChartLegend = true;
  public lineChartPlugins = [];

  ngOnInit(): void {}

  public setData(data: number[]) {
    this.data = data;
    this.data2 = data;
    this.lineChartData = {
      labels: [
        'Ene',
        'Feb',
        'Mar',
        'Abr',
        'May',
        'Jun',
        'Jul',
        'Ago',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
      datasets: [
        {
          label: '$',
          data: this.data,
          fill: false,
          tension: 0,
          hoverBackgroundColor: 'rgb(255,1,0)',
          borderColor: 'black',
          pointRadius: 10,
          pointBackgroundColor: 'black',
          pointBorderWidth: 5,
          pointHitRadius: 20,
        },
      ],
    };
    this.barChartData = {
      labels: [
        'Ene',
        'Feb',
        'Mar',
        'Abr',
        'May',
        'Jun',
        'Jul',
        'Ago',
        'Sep',
        'Oct',
        'Nov',
        'Dic',
      ],
      datasets: [
        {
          label: '$',
          data: this.data2,
          backgroundColor: 'rgb(215,236,251)',
          hoverBackgroundColor: 'rgb(255,1,0, 0.7)',
        },
      ],
    };
  }
}
